import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Entity } from '@inter-ikea-core/core';
import { ProductDesign, ProductType } from '@inter-ikea-storageone/range';
import { useCore } from 'contexts/core';
import { getProductEntities } from 'ducks/core';
import ChangeColor from 'components/ProductSidebar/menus/Widgets/ChangeColor/ChangeColor';
import { BoaxelCoreApi, PrimaryColor } from '@inter-ikea-storageone/range-boaxel';

const ChangeColorOnScene = () => {
  const boaxelCoreApi = useCore() as BoaxelCoreApi;
  const productEntities = useSelector(getProductEntities);
  const [mountingRailEntities, setMountingRailEntities] = useState<Entity[]>([]);

  useEffect(() => {
    const mountingRailEntities = boaxelCoreApi.entities.getByProductType(
      ProductType.BOAXEL_NON_MOUNTING_RAIL
    );
    setMountingRailEntities(mountingRailEntities);
  }, [boaxelCoreApi, productEntities]);

  const getAsPrimaryColor = (design: ProductDesign) =>
    Object.values(PrimaryColor).find(candidate => (candidate as string) === (design as string));

  const onChangeColor = (design: ProductDesign) => {
    const primaryColor = getAsPrimaryColor(design);
    if (!primaryColor) throw new Error('Not a primary color.');

    const rootMountingRails = mountingRailEntities.filter(
      rail => boaxelCoreApi.getMountingRailIndexInSolution(rail) === 0
    );
    rootMountingRails.forEach((rootMountingRail: Entity) => {
      const indexedMountingRails = boaxelCoreApi.indexMountingRailsInSolution(rootMountingRail);
      boaxelCoreApi.recolorSolution(primaryColor, Object.values(indexedMountingRails));
    });
  };

  return (
    <ChangeColor
      entities={mountingRailEntities}
      onChangeColor={onChangeColor}
      defaultColor={ProductDesign.WHITE}
    />
  );
};

export default ChangeColorOnScene;
